export default __webpack_public_path__ + "static/treasure-bamboo-mobile-be6dcfd9f547399b2f09f03c60ee35e4.png";